import { Container, Text } from "./style";
import { BadgeType, IBadgeProps } from "./types";

const badgeTheme: Record<
  BadgeType,
  { background: string; text: string; border: string }
> = {
  success: {
    background: "#f0fdf4",
    text: "#16a34a",
    border: "#bbf7d0",
  },
  danger: {
    background: "#fef2f2",
    text: "#dc2626",
    border: "#fecaca",
  },
  warning: {
    background: "#fefce8",
    text: "#ca8a04",
    border: "#fef08a",
  },
  ghost: {
    background: "#fafafa",
    text: "#737373",
    border: "#e5e5e5",
  },
  info: {
    background: "#f0f9ff",
    text: "#0ea5e9",
    border: "#bae6fd",
  },
};

export default function Badge({ type = "ghost", value = "" }: IBadgeProps) {
  const theme = badgeTheme[type];

  return (
    <Container
      backgroundColor={theme.background}
      borderColor={theme.border}
      borderWidth="1px"
      borderStyle="solid"
      borderRadius="18px"
      padding="2px 12px"
    >
      {value && (
        <Text color={theme.text} fontWeight="bold" fontSize="12px">
          {value}
        </Text>
      )}
    </Container>
  );
}
